import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Close, EditIcon, PenIcon } from 'src/icons/icons'
import { CrewMutateFormType } from '../Information'
import { createFileURL } from 'src/utils/new'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

export const AvatarSection = () => {

    const { register, control, watch , resetField , } = useFormContext<CrewMutateFormType>()

    const pic = watch('picture')

    const { t } = useTranslation()

    const avtar = require('../../../../../../assets/img/avatar.png')


    const imgURL = () => {

        if (typeof pic == 'string')
            return createFileURL(pic)

        else if (pic && typeof pic == 'object')
            return URL.createObjectURL(pic)

        return avtar
    }

    return (
        <div className='flex flex-col items-center gap-4'>

            <div className='relative'>


                <img src={imgURL()} className='bg-gray-100 rounded-full aspect-square w-32 overflow-hidden object-cover' />


                <Controller
                    control={control}
                    name='picture'
                    render={({ field: { onChange, value } }) => <input id='picture' onChange={({ target: { files } }) => files?.[0] instanceof File ? onChange({ target: { value: files?.[0] } }) : undefined} type='file' hidden accept='image/*' />}
                />

            </div>


            <div  className='flex flex-row gap-4 items-center abs olute left-0 bottom-0 cursor-pointer'>

                <div title={t('delete')} className={clsx('bg-red rounded-lg border p-1 aspect-square' , !pic && 'grayscale point er-events-none' )} onClick={()=>resetField('picture')}>
                    <Close color='white' />
                </div>

                <label title={t('edit')} htmlFor={'picture'} className='bg-primary-300 rounded-lg border p-1 aspect-square cursor-pointer'>

                    <PenIcon className='size-5 text-white' />

                </label>
            </div>


        </div>
    )
}
